import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { IoLogoBehance } from "react-icons/io5";
import { IoLogoBuffer, IoLogoPolymer, IoLogoVk } from "react-icons/io";
import { NavLink } from 'react-router-dom';
import { ConnectButton, RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import logo from "../../asstes/logo.jpg";
import pdf from '../../asstes/document.pdf'
const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  const handleNav = () => {
    setNav(!nav);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const countryList = [
    { icons: <IoLogoBuffer size={25} />, countryName: "Itali" },
    { icons: <IoLogoBehance size={25} />, countryName: "India" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Usa" },
    { icons: <IoLogoVk size={25} />, countryName: "Rusia" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Bangladesh" },
    { icons: <IoLogoPolymer size={25} />, countryName: "Pakisthan" },
    { icons: <IoLogoBehance size={25} />, countryName: "America" },
    { icons: <IoLogoBuffer size={25} />, countryName: "Chaina" }
  ]
  const handleOpenPDF = () => {
    window.open(pdf, '_blank');
  };


  return (
    <>
      <div className='shadow-xl fixed top-0 z-10 w-full flex justify-between items-center h-16  mx-auto text-white navbar-container '>
        {/* Desktop Navigation */}
        <div className='w-full flex md:justify-around justify-between items-center  regiter-navbar-main-container'>
          <div className='flex justify-around gap-6 items-center regiter-navbar-main-inner-container'>
            <NavLink to="/home">
              {/* <h3 className='text-gray-400 text-xl font-bold'  >Thinker</h3> */}
              <img src={logo} className='registrer-navbar-img'/>
            </NavLink>
            <button className='md:flex hidden text-white Documentation-btn-register-navbar' onClick={handleOpenPDF}>Documentation</button>
          </div>
          <div className='md:flex hidden z-20'>
            <div className=' '>
              {/*<div className="p-10">
                 <div className="dropdown inline-block relative">
                  <button className="bg-gray-300  text-gray-700 font-semibold py-2 px-4 rounded inline-flex items-center" onClick={toggleDropdown}>
                    <span className=" flex gap-2 mr-8"><span><IoLogoBuffer size={25} /></span> English</span>
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                  </button>
                  {isOpen && (
                    <ul className="dropdown-menu absolute text-gray-700 pt-1">
                      {
                        countryList.map((item, index) => (
                          <li key={index} className='flex cursor-pointer text-gray-400 items-center gap-5  bg-[#333]
                          hover:bg-gray-500 hover:text-slate-50 rounded-md  my-2 py-2 px-4  whitespace-no-wrap'> <span className='text-white'>{item.icons}</span><p className="">{item.countryName}</p>
                            <hr />
                          </li>
                        ))
                      }
                    </ul>
                  )}
                </div>
              </div> */}
            </div>
          </div>
          <div className=' justify-around gap-8 items-center hidden md:flex'>
            {/* <NavLink to="/" className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "navbar-btn-color rounded-[20px]  " : ""
            }
            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>Login</button>
            </NavLink>
            <NavLink to="fetch-user" className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "navbar-btn-color rounded-[20px]  " : ""
            }
            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>User</button>
            </NavLink> */}
            <NavLink to="dashboard"
              className={({ isActive, isPending }) =>
                isPending ? "pending" : isActive ? "navbar-btn-color rounded-[20px]  " : "navbar-isActive-btn-register"
              }
            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>DashBoard</button>
            </NavLink>
            <NavLink to="register"
              className="navbar-btn-color rounded-[20px]"
            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>Register</button>
            </NavLink>
            
            <RainbowKitProvider
                  theme={darkTheme({
                    accentColor: "#E43B4D",
                    accentColorForeground: "white",
                    borderRadius: "large",
                    fontStack: "system",
                    overlayBlur: "small",
                  })}
                >
                  <ConnectButton className="ConnectButton-color" />
                </RainbowKitProvider>
          </div>
        </div>
        {/* Mobile Navigation Icon */}
        <div onClick={handleNav} className='block md:hidden'>
          {nav ? "" : <AiOutlineMenu size={25} />}
        </div>

        {/* Mobile Navigation Menu */}
        <ul
          className={
            nav
              ? 'fixed md:hidden left-0 top-0 w-[100%] h-full  bg-[#000300] ease-in-out duration-500'
              : 'ease-in-out w-[100%] duration-500 fixed top-0 bottom-0 left-[-100%]'
          }
        >
          {/* Mobile Logo */}
          <div className='flex justify-between'>
            <h1 className='w-full text-3xl font-bold text-[#fff] m-4'>Thinker</h1>
            <div onClick={handleNav} className='block md:hidden my-8 px-4 cursor-default'>
              {nav ? <AiOutlineClose size={25} /> : ""}
            </div>
          </div>


          {/* Mobile Navigation Items */}
          <div className=' flex-col flex px-10 w-full mx-auto my-10'>
            <NavLink onClick={handleNav} to="/"
            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>Login</button>
            </NavLink>
            <NavLink onClick={handleNav} to="fetch-user"

            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>User</button>
            </NavLink>
            <NavLink onClick={handleNav} to="register"

            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>Register</button>
            </NavLink>
            <NavLink onClick={handleNav} to="dashboard"

            >
              <button className='font-bold navbar-btn-color-hover rounded-[20px] py-2 px-4'>DashBoard</button>
            </NavLink>
            <button className='font-bold  rounded-lg py-3 px-4'><ConnectButton /></button>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Navbar;